module.exports = __webpack_public_path__ + "img/m-banner-csrrksao-tr-TR.e8eaf239.jpg";